import React, { useState, useEffect } from "react";
import "../../folkdashboard.css";
import { useLocation } from "react-router-dom";
import { apiHelper, baseUrl } from "helpers/util";
import { message } from "antd";

import LevelWiseReport from "./components/FOLKLevelWiseReport";
import AshrayaWiseReport from "./components/AshrayaWiseReport";
import FolkGuideWiseReport from "./components/FolkGuideWiseReport";
import TestOntimeBar from "./components/OntimeReport";

export default function SundayReport() {
    const [attendanceCount, setAttendanceCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState({});
    const [isGenerating, setIsGenerating] = useState({});
    const [activeReport, setActiveReport] = useState(null);
    const location = useLocation();

    const generateReport = async (type, url) => {
        setIsGenerating((p) => ({ ...p, [type]: true }));
        try {
            console.log(`Fetching report: ${type} from ${url}`);
            const res = await apiHelper.get({
                url: `${baseUrl}/.netlify/functions/${url}`,
            });
            
            if (res.status && res.json) {
                setReportData((p) => ({ ...p, [type]: res.json }));
                setActiveReport(type);
                if (type !== "ontime") {
                    message.success(`${type} report loaded successfully`);
                }
            } else {
                message.error(`Failed to load ${type} report`);
                console.error(`Report error for ${type}:`, res);
            }
        } catch (err) {
            console.error(`Error generating ${type} report:`, err);
            message.error(`Error loading ${type} report: ${err.message}`);
        } finally {
            setIsGenerating((p) => ({ ...p, [type]: false }));
        }
    };

    const fetchAttendanceCount = async () => {
        setLoading(true);
        try {
            const response = await apiHelper.get({
                url: `${baseUrl}/.netlify/functions/marked_attendance`,
            });

            if (response.status && response.json) {
                setAttendanceCount(response.json.attendanceCount);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const getTodayDate = () => {
        const d = new Date();
        return `${String(d.getDate()).padStart(2, "0")}/${String(
            d.getMonth() + 1
        ).padStart(2, "0")}/${d.getFullYear()}`;
    };

    useEffect(() => {
        fetchAttendanceCount();
        if (location.state?.attendanceCount) {
            setAttendanceCount(location.state.attendanceCount);
        }
    }, [location.state]);

    return (
        <div className="folk-container" style={{ width: "100%", boxSizing: "border-box", padding: "0 10px" }}>
            <div
                style={{
                    padding: "20px",
                    background: "#d1ecf1",
                    borderRadius: "10px",
                    maxWidth: "100%",
                    margin: "0 auto 30px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                }}
            >
                <div>Sunday Attendance Count: {attendanceCount}</div>
                <button
                    onClick={fetchAttendanceCount}
                    disabled={loading}
                    style={{
                        padding: "8px 14px",
                        fontSize: "14px",
                        background: loading ? "#6c757d" : "linear-gradient(135deg, #17a2b8, #138496)",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: loading ? "not-allowed" : "pointer",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        transition: "all 0.2s ease",
                    }}
                >
                    🔄 {loading ? "Refreshing..." : "Refresh"}
                </button>
            </div>

            {/* ---------- BUTTON GRID ---------- */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, 1fr)",
                    gap: 10,
                    maxWidth: "100%",
                    width: "100%",
                    margin: "0 auto 20px",
                    boxSizing: "border-box",
                    padding: "0 5px",
                }}
            >
                {[
                    ["folk", "FOLK Level Wise Report", "#28a745", "folk_level_wise_report"],
                    ["ashraya", "Ashraya Wise Report", "#17a2b8", "ashraya_wise_report"],
                    ["guide", "FOLK Guide Wise Report", "#6f42c1", "folk_guide_wise_report"],
                    ["ontime", "Ontime Report", "#fd7e14", "ontime_report"],
                ].map(([key, label, color, apiUrl]) => (
                    <button
                        key={key}
                        onClick={() => generateReport(key, apiUrl)}
                        disabled={isGenerating[key]}
                        style={{
                            padding: 12,
                            fontSize: 13,
                            background: color,
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            width: "100%",
                            fontWeight: 600,
                            cursor: isGenerating[key] ? "not-allowed" : "pointer",
                            opacity: isGenerating[key] ? 0.7 : 1,
                            boxSizing: "border-box",
                        }}
                    >
                        {isGenerating[key] ? "Generating..." : label}
                    </button>
                ))}
            </div>

            {/* ---------- REPORT CONTAINER ---------- */}
            {activeReport && (
                <div
                    style={{
                        maxWidth: "100%",
                        width: "100%",
                        margin: "0 auto",
                        padding: 0,
                        boxSizing: "border-box",
                    }}
                >
                    {activeReport === "ontime" && (
                        <TestOntimeBar
                            getTodayDate={getTodayDate}
                            onClose={() => setActiveReport(null)}
                        />
                    )}
                    {activeReport === "folk" && reportData.folk && (
                        <LevelWiseReport
                            data={reportData.folk}
                            getTodayDate={getTodayDate}
                            onClose={() => setActiveReport(null)}
                        />
                    )}
                    {activeReport === "ashraya" && reportData.ashraya && (
                        <AshrayaWiseReport
                            data={reportData.ashraya}
                            getTodayDate={getTodayDate}
                            onClose={() => setActiveReport(null)}
                        />
                    )}
                    {activeReport === "guide" && reportData.guide && (
                        <FolkGuideWiseReport
                            data={reportData.guide}
                            getTodayDate={getTodayDate}
                            onClose={() => setActiveReport(null)}
                        />
                    )}
                </div>
            )}
        </div>
    );
}
